import { CheckCircle } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Chip, Typography } from "@mui/material";
import { AdminRoutes } from "config/routes";
import { useAuthUser } from "hooks/useAuthUser";
import { useVetcoin } from "hooks/useVetcoin";
import { EquippedAnimationPresentation } from "components/VetStore/EquippedAnimationPresentation";
import { StoreItemPreview } from "components/VetStore/StoreItemPreview";
import { Link } from "react-router-dom";

type SubmissionConfirmationCardProps = {
  title: string;
  vetcoinsAwarded: number;
  buttonText?: string;
  buttonTo?: string;
};

export const SubmissionConfirmationCard = ({
  title,
  vetcoinsAwarded,
  buttonText = "Return Home",
  buttonTo = AdminRoutes.Home,
}: SubmissionConfirmationCardProps) => {
  const { user } = useAuthUser();
  const { getEquippedByType } = useVetcoin(user?.user_id);
  const equippedPet = getEquippedByType("PET")?.store_item;
  const equippedAnimation = getEquippedByType("ANIMATION")?.store_item;

  return (
    <>
      <EquippedAnimationPresentation item={equippedAnimation} />
      <Card>
        <CardContent>
          <Box py={4}>
            <Box textAlign="center" mb={4}>
              <CheckCircle color="success" sx={{ fontSize: 48 }} />
            </Box>
            <Typography align="center" variant="h6">
              {title}
            </Typography>
            <Box mt={2} display="flex" justifyContent="center">
              <Chip label={`+${vetcoinsAwarded} Vetcoins acquired`} color="success" />
            </Box>
            {(equippedPet || equippedAnimation) && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={1}
                sx={{ mt: 2, lineHeight: 0 }}
              >
                {equippedPet && (
                  <Box sx={{ width: 140, height: 140, m: 0, p: 0, lineHeight: 0 }}>
                    <StoreItemPreview item={equippedPet} size="large" chromeless />
                  </Box>
                )}
                {equippedAnimation && (
                  <Box sx={{ width: 140, height: 140, m: 0, p: 0, lineHeight: 0 }}>
                    <StoreItemPreview
                      item={equippedAnimation}
                      size="large"
                      chromeless
                    />
                  </Box>
                )}
              </Box>
            )}
            <Box textAlign="center" mt={4}>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to={buttonTo}
              >
                {buttonText}
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
